var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartStroked = function SvgHeartStroked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.4,
    d: "M11.813 19.739a.49.49 0 0 1-.626 0l-1.064-.89C5.23 14.777 2 12.083 2 8.796 2 6.1 4.299 4 7.225 4c1.653 0 3.24.706 4.275 1.814C12.536 4.706 14.122 4 15.775 4 18.701 4 21 6.101 21 8.796c0 3.287-3.23 5.981-8.123 10.053z"
  })));
};
export default SvgHeartStroked;